export enum ProposalStateEnum {
    ACCEPTED = "Accepted",
    PENDING = "Pending",
    DRAFT = "Draft",
    COUNTER_PROPOSAL = "CounterProposal",
    REJECTED = "Rejected",
    EXPIRED = "Expired"
}